var map = {
	"./en.json": 790,
	"./zh-CN.json": 9890,
	"./zh-TW.json": 6687,
	"locales/en.json": 790,
	"locales/zh-CN.json": 9890,
	"locales/zh-TW.json": 6687
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3604;